/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your typed name into a signature. Enter your name, pick a handwriting style, and download it as a transparent PNG.`)
};

const es_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte tu nombre escrito en una firma. Ingresa tu nombre, elige un estilo de escritura manual y descárgalo como PNG transparente.`)
};

const de_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie Ihren eingegebenen Namen in eine Signatur. Geben Sie Ihren Namen ein, wählen Sie einen Handschriftstil und laden Sie ihn als transparentes PNG herunter.`)
};

const nl_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet uw getypte naam om in een handtekening. Voer uw naam in, kies een handschriftstijl en download het als transparante PNG.`)
};

const fr_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez votre nom dactylographié en signature. Entrez votre nom, choisissez un style manuscrit et téléchargez-le en tant que PNG transparent.`)
};

const it_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma il tuo nome digitato in una firma. Inserisci il tuo nome, scegli uno stile calligrafico e scaricalo come PNG trasparente.`)
};

const pt_br2_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme seu nome digitado em uma assinatura. Digite seu nome, escolha um estilo cursivo e baixe como PNG transparente.`)
};

const pt_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme o seu nome digitado em assinatura. Introduza o seu nome, escolha um estilo de caligrafia e descarregue como PNG transparente.`)
};

const ja_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力した名前を署名に変えます。名前を入力し、手書きスタイルを選択してから、透明なPNGとしてダウンロードします。`)
};

const zh_sig_type_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将您输入的名字转换为签名。输入您的名字，选择笔迹风格，然后将其下载为透明 PNG。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_intro", locale)
	if (locale === "en") return en_sig_type_intro(inputs)
	if (locale === "es") return es_sig_type_intro(inputs)
	if (locale === "de") return de_sig_type_intro(inputs)
	if (locale === "nl") return nl_sig_type_intro(inputs)
	if (locale === "fr") return fr_sig_type_intro(inputs)
	if (locale === "it") return it_sig_type_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_intro(inputs)
	if (locale === "pt") return pt_sig_type_intro(inputs)
	if (locale === "ja") return ja_sig_type_intro(inputs)
	return zh_sig_type_intro(inputs)
};